"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const core_json_1 = require("./core-json");
exports.CoreDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Core', core_json_1.CoreJsonMapper);
